var exports = {
  "a": "Box__TU_Qdo",
};

module.exports = exports;
